import type { IntlShape } from 'react-intl';

import { type ErrorKey, ErrorKeySet, type ValidationError } from '../../types/field-validation';
import { messages } from './messages';

export const getFailedRequiredValidationError = (
	fieldLabel: string,
	intl?: IntlShape,
): ValidationError =>
	getFailedValidationError(
		ErrorKeySet.REQUIRED,
		intl?.formatMessage(messages.required, { fieldLabel }),
	);
export const getFailedValidationError = (
	errorKey: ErrorKey,
	errorMessage?: string,
): ValidationError => ({
	errorKey,
	errorMessage,
});
